module.exports = __webpack_public_path__ + "3208703272f9a353494b61ee53085a20.svg";